import React from 'react';


export default function AboutSite(props) {
    return (
        <div className="container">
            <div className="card mt-2 p-3">
                <h2>About This Site</h2>

                <p>
                    This is the Personal & Professional web site of <b>Chris Roberts</b>.
                </p>
                <h4>Privacy Policy & Cookies</h4>
                <p>
                    This site uses cookies for functional purposes only. No personal information is collected, or shared with third parties. This site does
                    not host advertising, and has no ad networks or trackers. Minimal user information, such as an email address is collected for use with 
                    some applications on this site, however this information will not be sold or shared with any party without your consent. 
                </p> 
                <br />
               

                {/* <h3>Credits</h3> */}

                

            </div>
        </div>
    );

};



